import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, CardBody } from "reactstrap";

// router dom
import { Link } from "react-router-dom";

import Logo from "../../../assets/images/logo/metiner_avantaj_yatay_logo.png";
import Target from "../../../assets/images/target-audience.png";

const Error = () => {
  document.title = "Hoşgeldiniz | Metiner Avantaj+";

  return (
    <React.Fragment>
      <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <CardBody className="p-lg-5 p-4 text-center">
                    <div className="avatar-lg mx-auto mt-2">
                      <img
                        src={Target}
                        alt="Metiner Avantaj+ Target"
                        height="110"
                      />
                    </div>
                    <div className="mt-4 pt-2 mb-4">
                      <h5>
                        Telefon numaranız ile bu kampanyadan daha önce bir kez
                        faydalanmışsınız. Kampanya her müşteri için 1 defaya
                        özeldir.
                      </h5>
                    </div>
                    <div className="text-center">
                      <Link to="/" className="d-inline-block auth-logo">
                        <img src={Logo} alt="Metiner Avantaj+" height="46" />
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer h-auto pb-2">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted">
                  <p className="mb-2" style={{ letterSpacing: "0.8px" }}>
                    Metiner Avantaj+ &copy; {new Date().getFullYear()} | 0 352 3
                    555 444 | metiner@boschservice.com.tr
                    <br />
                    <i className="mdi mdi-heart text-danger"></i> by{" "}
                    <a
                      href="https://kodexis.com/"
                      target="_blank"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Kodexis
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default Error;
